/* eslint-disable react/display-name */
import {
  Button,
  Col,
  ContentBody,
  ContentHeader,
  Drawer,
  Dropdown,
  Input,
  Menu,
  MenuItem,
  RangeDatePicker,
  Row,
  Table
} from '../../core/components'
import { Link } from 'react-router-dom'
import { routesConfig } from '../../core/configs/routes'
import {
  CheckOutlined,
  DownOutlined,
  EditOutlined,
  FilterOutlined
} from '@ant-design/icons'
import { dateTimeFormat } from '../../utils/format/dateTimeFormat'
import { ChangeEvent, useEffect, useMemo, useState } from 'react'
import { CustomerType, OpportunityFilter, Pagination } from '../../entities'
import { Select as AntdSelect } from 'antd'
// import useOpportunityCampaigns from '../../services/queries/opportunity/useOpportunityCampaigns'
import useApproveOrder from '../../services/mutations/useApproveOrder'
import useOrders from '../../services/queries/order/useOrders'
import { dateFormat } from '../../utils/format/dateFormat'

const filterDefaultValue = {
  search: '',
  concept: '',
  event: '',
  // campaign: '',
  createdAt: {
    startDate: '',
    endDate: ''
  }
}

const { Option } = AntdSelect

export const OrderPage = () => {
  const [pagination, setPagination] = useState<Pagination>({
    page: 1,
    limit: 10
  })
  const [showFilter, setShowFilter] = useState<boolean>(false)

  const [filters, setFilters] = useState<OpportunityFilter>(filterDefaultValue)
  const [filterState, setFilterState] =
    useState<OpportunityFilter>(filterDefaultValue)

  const { data, isLoading, isFetching, isPreviousData } = useOrders({
    ...pagination,
    filters
  })

  const { mutate: approveOrder } = useApproveOrder()

  const handleSearch = (e: ChangeEvent<HTMLInputElement>) => {
    setFilterState((prev: OpportunityFilter) => ({
      ...prev,
      search: e.target.value.toUpperCase()
    }))
  }

  const handlePagination = (page: number, limit: number) => {
    setPagination({ page, limit })
  }

  const handleReset = () => {
    setFilterState(filterDefaultValue)
    setFilters(filterDefaultValue)
  }

  useEffect(() => {
    if (filterState.search === '')
      setFilters((prev) => ({ ...prev, search: '' }))
  }, [filterState.search])

  // const menu = (obj: any) => {
  //   return (
  //     <Menu>
  //       {obj.situation.id === '10' && (
  //         <Link to={routesConfig.oportunities.oportunity.list + `/${obj.id}`}>
  //           <MenuItem icon={<EditOutlined />}>Editar</MenuItem>
  //         </Link>
  //       )}
  //       {obj.situation.id === '10' && (
  //         <Button onClick={() => approveOrder(obj.orderId)}>
  //           <MenuItem icon={<CheckOutlined />}>Aprovar</MenuItem>
  //         </Button>
  //       )}
  //     </Menu>
  //   )
  // }

  const columns = useMemo(
    () => [
      {
        title: 'Nº Pedido',
        dataIndex: 'id',
        key: 'id',
        render: (value: any, row: any) => {
          return (
            <Link
              to={routesConfig.orders.order.details + `/${row.id}/detalhes`}
            >
              {value}
            </Link>
          )
        }
      },
      {
        title: 'Cliente',
        dataIndex: 'customer',
        render: (value: CustomerType) => (value ? value.name : '')
      },

      {
        title: 'Data/Hora',
        dataIndex: 'orderDate',
        key: 'orderDate',
        render: (value: string) => (value ? dateFormat(value) : null)
      }
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )

  const handleShowFilter = () => {
    setShowFilter((prev: boolean) => !prev)
  }

  const handleClear = (key: string) => {
    setFilters((prev) => ({ ...prev, [key]: '' }))
    setFilterState((prev) => ({ ...prev, [key]: '' }))
  }

  const handleDateClear = () => {
    console.log('clearDate')
    setFilters((prev) => ({
      ...prev,
      createdAt: { startDate: '', endDate: '' }
    }))
    setFilterState((prev) => ({
      ...prev,
      createdAt: { startDate: '', endDate: '' }
    }))
  }
  return (
    <>
      <ContentHeader>Pedidos</ContentHeader>
      <ContentBody>
        <Row style={{ marginBottom: 10 }}>
          <Col>
            <Input
              allowClear
              value={filterState.search}
              placeholder="Pesquisar cliente ..."
              style={{ width: '385px', marginBottom: 20 }}
              onChange={(e) => handleSearch(e)}
              onPressEnter={() => setFilters(filterState)}
            />
          </Col>
          <Col>
            <Button
              htmlType="submit"
              type="primary"
              style={{ width: 100, marginLeft: 20 }}
              onClick={() => setFilters(filterState)}
            >
              Procurar
            </Button>
            <Button style={{ marginLeft: 10 }} onClick={handleReset}>
              Reiniciar
            </Button>
            <Button
              style={{ marginLeft: 10 }}
              onClick={handleShowFilter}
              icon={<FilterOutlined />}
            >
              Filtros
            </Button>
          </Col>
        </Row>
        <Table
          loading={(isLoading || isFetching) && isPreviousData}
          dataSource={data?.data}
          columns={columns}
          pagination={{
            pageSize: pagination.limit,
            current: pagination.page,
            total: data?.total,
            onChange: (page, limit) => handlePagination(page, limit || 10)
          }}
          // onChange={handleTableChange}
          bordered
          rowKey={(row) => row.id}
        />
        <Drawer
          title="Filtros"
          width={520}
          closable={false}
          onClose={handleShowFilter}
          visible={showFilter}
          footer={
            <div
              style={{
                textAlign: 'right',
                paddingBottom: 30,
                paddingTop: 30
              }}
            >
              <Button
                onClick={() => {
                  handleReset()
                  handleShowFilter()
                }}
                style={{ marginRight: 8 }}
              >
                Reiniciar
              </Button>
              <Button
                onClick={() => {
                  setFilters(filterState)
                  handleShowFilter()
                }}
                type="primary"
              >
                Aplicar
              </Button>
            </div>
          }
        >
          <Row>
            <Col span={24}>
              <RangeDatePicker
                label="Data Realização"
                format={'DD/MM/YYYY'}
                // onOk={onOk}
                allowClear
                placeholder={['Data Inicial', 'Data Final']}
                onClear={handleDateClear}
                onChange={(e: any) => {
                  if (!e) handleDateClear()
                  setFilterState((prev) => ({
                    ...prev,
                    createdAt: {
                      startDate: e?.[0] || '',
                      endDate: e?.[1] || ''
                    }
                  }))
                }}
              />
            </Col>
          </Row>
        </Drawer>
      </ContentBody>
    </>
  )
}
